import Vue from 'vue'
import Router from 'vue-router'
import main from '@/view/main.vue'
import login from '@/view/login.vue'
import index from '@/view/index.vue'
// 用户管理
import user from '@/view/userManagement/user.vue'
import admin from '@/view/userManagement/admin.vue'
import enterprise from '@/view/userManagement/enterprise.vue'
import shool from '@/view/userManagement/shool.vue'
import userDetail from '@/view/userManagement/userDetail.vue'
// import userDetail from '@/view/userManagement/userDetail.vue'
//内容管理
import dataStatistics from '@/view/contentManagement/dataStatistics.vue'
import allContent from '@/view/contentManagement/allContent.vue'
import contentFiltering from '@/view/contentManagement/contentFiltering.vue'
// 认证审核
import studentexamine from '@/view/authentication/student.vue'
import teacherexamine from '@/view/authentication/teacher.vue'
import adminexamine from '@/view/authentication/admin.vue'
import enterpriseexamine from '@/view/authentication/enterprise.vue'
// 返校
import appointment from '@/view/backSchool/appointment.vue'
import backStatistic from '@/view/backSchool/backSchoolStatistic/index.vue'

// 意见反馈
import feedback from '@/view/feedback.vue'
import wishManage from '@/view/wishManage/appointment.vue'


// 行业领域
import industryField from '@/view/industryField/index.vue'



Vue.use(Router)
//避免路径重复报错 获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    routes: [{
        path: '/',
        redirect: {
            path: '/login'
        },
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        mate: {
            title: '登录'
        }
    },
    {
        path: '/main',
        name: 'main',
        component: main,
        redirect: {
            path: '/main/index'
        },
        children: [{
            path: 'index',
            name: 'index',
            component: index,
            meta: {
                requireAuth: true,
                title: '首页'
            }
        },
        {
            path: 'industryField',
            name: 'industryField',
            component: industryField,
            meta: {
                requireAuth: true,
                title: '行业领域'
            }
        },
        {
            path: 'wishManage',
            name: 'wishManage',
            component: wishManage,
            meta: {
                requireAuth: true,
                title: '心愿管理'
            }
        }, {
            path: 'feedback',
            name: 'feedback',
            component: feedback,
            meta: {
                requireAuth: true,
                title: '意见反馈'
            }
        },]
    },
    {
        path: '/userManagement',
        name: 'userManagement',
        component: main,
        redirect: {
            path: '/userManagement/user'
        },
        meta: {
            title: '用户管理'
        },
        children: [{
            path: 'user',
            name: 'user',
            component: user,
            meta: {
                requireAuth: true,
                title: '用户管理'
            }
        }, {
            path: 'admin',
            name: 'admin',
            component: admin,
            meta: {
                requireAuth: true,
                title: '管理员管理'
            }
        },
        {
            path: 'shool',
            name: 'shool',
            component: shool,
            meta: {
                requireAuth: true,
                title: '学校管理'
            }
        },
        {
            path: 'enterprise',
            name: 'enterprise',
            component: enterprise,
            meta: {
                requireAuth: true,
                title: '企业管理'
            }
        },
        {
            path: 'userDetail',
            name: 'userDetail',
            component: userDetail,
            meta: {
                requireAuth: true,
                title: '用户详情'
            }
        },

        ]
    },
    {

        path: '/contentManagement',
        name: 'contentManagement',
        component: main,
        redirect: {
            path: '/contentManagement/dataStatistics'
        },
        meta: {
            title: '内容管理'
        },
        children: [{
            path: 'dataStatistics',
            name: 'dataStatistics',
            component: dataStatistics,
            meta: {
                requireAuth: true,
                title: '数据统计'
            }
        },
        {
            path: 'allContent',
            name: 'allContent',
            component: allContent,
            meta: {
                requireAuth: true,
                title: '全部内容'
            }
        },
        {
            path: 'contentFiltering',
            name: 'contentFiltering',
            component: contentFiltering,
            meta: {
                requireAuth: true,
                title: '内容过滤'
            }
        },

        ]
    },
    {
        path: '/authentication',
        name: 'authentication',
        component: main,
        redirect: {
            path: '/authentication/student'
        },
        meta: {
            title: '内容管理'
        },
        children: [{
            path: 'student',
            name: 'studentexamine',
            component: studentexamine,
            meta: {
                requireAuth: true,
                title: '学生认证'
            }
        },
        {
            path: 'teacher',
            name: 'teacherexamine',
            component: teacherexamine,
            meta: {
                requireAuth: true,
                title: '教职工认证'
            }
        },
        {
            path: 'admin',
            name: 'adminexamine',
            component: adminexamine,
            meta: {
                requireAuth: true,
                title: '管理员认证'
            }
        },
        {
            path: 'enterprise',
            name: 'enterpriseexamine',
            component: enterpriseexamine,
            meta: {
                requireAuth: true,
                title: '企业认证'
            }
        },
        ]
    },
    {
        path: '/backSchool',
        name: 'backSchool',
        component: main,
        redirect: {
            path: '/backSchool/appointment'
        },
        meta: {
            title: '返校预约'
        },
        children: [{
            path: 'appointment',
            name: 'appointment',
            component: appointment,
            meta: {
                requireAuth: true,
                title: '预约管理'
            }
        },
        {
            path: 'backStatistic',
            name: 'backStatistic',
            component: backStatistic,
            meta: {
                requireAuth: true,
                title: '返校统计'
            }
        }
        ]
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js